import { Pipe, PipeTransform } from '@angular/core';
import { DateUtilities } from 'src/app/core/utilities/date.utilities';

@Pipe({name: 'dateFormatter'})
export class DateFormatterPipe implements PipeTransform {
  transform(value: Date | string | null): string {
    return DateUtilities.format(value)
  }
}
